module.exports = __webpack_public_path__ + "static/media/kr.146730ea.png";